import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticatedComponent } from 'app/shared/layout/authenticated/authenticated.component';
import { AuthGuard } from 'app/shared/guards/auth.guard';
import { ListCampaignsComponent } from './list-campaigns/list-campaigns.component';
import { EditCampaignComponent } from './edit-campaign/edit-campaign.component';
import { PreviewContentComponent } from './preview-content/preview-content.component';
import { EditTemplateComponent } from './edit-template/edit-template.component';
import { ECampaignCreateState } from 'app/store/models/campaigns.model';
import { CommunicationContentComponent } from './communication-content/communication-content.component';
import { BlockedDatesV2Component } from './blocked-dates-v2/blocked-dates-v2.component';
import { RoleGuard } from '../shared/guards/role.guard';
import { EditBlockedDateComponent } from './edit-blocked-date/edit-blocked-date.component';
import { UserType } from '../store/models/user.model';

const routes: Routes = [
  {
    path: '',
    component: AuthenticatedComponent,
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        component: ListCampaignsComponent,
      },
      {
        path: 'new',
        canActivate: [AuthGuard, RoleGuard],
        component: EditCampaignComponent,
        data: {
          state: ECampaignCreateState.CREATE,
          roles: [UserType.SINGLE_USER]
        },
      },
      {
        path: 'block_dates',
        canActivate: [AuthGuard],
        component: BlockedDatesV2Component,
      },
      {
        path: 'blocked_dates/edit',
        canActivate: [AuthGuard, RoleGuard],
        component: EditBlockedDateComponent,
        data: {
          roles: [UserType.MASTER, UserType.MANAGER, UserType.SINGLE_USER],
          state: 'new',
        },
      },
      {
        path: 'blocked_dates/edit/:id',
        canActivate: [AuthGuard, RoleGuard],
        component: EditBlockedDateComponent,
        data: {
          roles: [UserType.MASTER, UserType.MANAGER, UserType.SINGLE_USER],
          state: 'edit',
        },
      },
      {
        path: ':id/edit',
        canActivate: [AuthGuard],
        component: EditCampaignComponent,
        data: {
          state: ECampaignCreateState.EDIT,
        },
      },
      {
        path: ':id/preview-content',
        canActivate: [AuthGuard],
        component: PreviewContentComponent,
        data: {
          state: ECampaignCreateState.EDIT,
        },
      },
      {
        path: ':id/preview-content/:templateId',
        canActivate: [AuthGuard],
        component: EditTemplateComponent,
        data: {
          state: ECampaignCreateState.EDIT,
        },
      },
      {
        path: ':id/communication-content',
        canActivate: [AuthGuard],
        component: CommunicationContentComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CampaignsRoutingModule {
}
